// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from 'react';

import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Hotspot from '@cloudscape-design/components/hotspot';
import Input, { InputProps } from '@cloudscape-design/components/input';
import Link from '@cloudscape-design/components/link';


import { Box, Modal } from '@cloudscape-design/components';
import Flashbar, { FlashbarProps } from '@cloudscape-design/components/flashbar';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { mdiEyeOffOutline, mdiEyeOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { addNotification, base64Encode, clearNotifications, getCookie, getParameter, getUrlVersion, saveMasters, setData, setIdAirport, setIdUser, setLoading, setMenu, setName } from '../../../commons/functions'; // Import the function
import { useGlobalState } from '../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';


export const UserLoginPage = () => {
  const { idUser, user, name, idAirport, data, menu } = useGlobalState();

  const [inputUser, setInputUser] = useState('');
  const [inputPassword, setInputPassword] = useState(''); //Arl3quin$$
  const [infoRestoreCode, setInfoRestoreCode] = useState('');
  const [infoRestoreCodePwd1, setInfoRestoreCodePwd1] = useState('');
  const [infoRestoreCodePwd2, setInfoRestoreCodePwd2] = useState('');

  const [errors, setErrors] = useState<string[]>([]);
  const [showPassword, setShowPassword] = useState(false);
  const [revealPassword, setRevealPassword] = useState(false);
  const [revealNewPassword, setRevealNewPassword] = useState(false);
  const [revealNewConfirmation, setRevealNewConfirmation] = useState(false);
  const [passWordType, setPassWordType] = useState('password');
  const [init, setInit] = useState(false);
  const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
  const [messagesModal, setMessagesModal] = useState<FlashbarProps.MessageDefinition[]>([]);
  const [isDisabledUser, setIsDisabledUser] = useState(false);
  const inputRefUser = useRef<HTMLInputElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const inputRefPwd = useRef<HTMLInputElement>(null);
  const [isDisabledBtnNext, setIsDisabledBtnNext] = useState(true);
  const [recoveryMethod, setRecoveryMethod] = useState('');
  const [showModalStep1, setShowModalStep1] = useState(true);
  const [showModalStep2, setShowModalStep2] = useState(false);

  const [isResetModalOpen, setIsResetModalOpen] = useState(false); // State for the reset password modal
  const [isDisabledCodeType, setIsDisabledCodeType] = useState(true); // State for the reset password modal


  const handleInfoRestoreCode: InputProps["onChange"] = (event) => {
    setInfoRestoreCode(event.detail.value);
  };
  const handleInfoRestoreCodePwd1: InputProps["onChange"] = (event) => {
    setInfoRestoreCodePwd1(event.detail.value);
    validatePassword(event.detail.value);
  };
  const handleInfoRestoreCodePwd2: InputProps["onChange"] = (event) => {
    setInfoRestoreCodePwd2(event.detail.value);
  };

  const handlePasswordChange: InputProps["onChange"] = (event) => {
    setInputPassword(event.detail.value);
    setMessages([]);
  };

  const [shouldRedirect, setShouldRedirect] = useState(false);
  useEffect(() => {
    return;

  }, [shouldRedirect]);
  useEffect(() => {
    setMessages([]);
    console.log(inputUser.length < 4);
    setIsDisabledBtnNext(inputUser.length < 4);
  }, [user, inputUser]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setInputUser(user)
      setInputPassword('')
      setIsDisabledBtnNext(user.length < 4)
      if (inputRefUser.current) {
        inputRefUser.current.focus();
        setIsDisabledBtnNext(user.length < 4);
      }
    }, 500); // 2000 milliseconds = 2 seconds

    // Cleanup if component unmounts
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!showModalStep1) {
      // Code to execute after the modal is hidden (if needed)
      setLoading(false)
    }
    if (!showModalStep2) {
      // Code to execute after the modal is hidden (if needed)
      setLoading(false)
    }
  }, [showModalStep1, showModalStep2]);
  const handleCloseSendResetModal = async () => { // Make the function async
    setPendingJobCreation(true);
    try {
      const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/user/reset.password',
        },
        body: JSON.stringify({
          userName: inputUser,
        }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      if (data.code == 0) {
        //setIsResetModalOpen(false); // Update the modal visibility state

        setShowModalStep1(false);
        setShowModalStep2(true);

        setMessagesModal([
          {
            type: 'success',
            content: data.status,
            id: 'server-success',
          },
        ]);

      } else {
        setMessagesModal([
          {
            type: 'error',
            content: `${data.status}`,
            id: 'server-error',
          },
        ]);
      }
    } catch (error: any) {
      setMessagesModal([
        {
          type: 'error',
          content: `Error al contactar el servidor: ${error.message}`,
          id: 'server-error',
        },
      ]);
    } finally {
      setPendingJobCreation(false);
      console.log("END")
    }
  };

  const handleResetPassword = () => {
    setIsResetModalOpen(true); // Update the modal visibility state
    setIsDisabledCodeType(true)
    setRecoveryMethod('');
    setShowModalStep1(true)
    setShowModalStep2(false)
    setMessagesModal([])

  };

  const handleCloseResetModal = () => {
    setIsResetModalOpen(false); // Update the modal visibility state
  };

  const handleCloseSendRestoreModal = async () => {
    if (infoRestoreCode.length !== 6) {

      setMessagesModal([
        {
          type: 'error',
          content: 'Código de restauración debe ser de 6 dígitos',
          id: 'server-error',
        },
      ]);
      return
    }

    if (infoRestoreCodePwd1.length < 7) {

      setMessagesModal([
        {
          type: 'error',
          content: 'Contraseña debe ser de al menos 8 caracteres',
          id: 'server-error',
        },
      ]);
      return
    }

    if (infoRestoreCodePwd1 !== infoRestoreCodePwd2) {

      setMessagesModal([
        {
          type: 'error',
          content: 'Contraseña y confirmación no son iguales',
          id: 'server-error',
        },
      ]);
      return
    }

    setMessagesModal([])

    setPendingJobCreation(true);
    try {
      setLoading(true)
      const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/user/restore.password',
        },
        body: JSON.stringify({
          userName: inputUser,
          restoreCode: infoRestoreCode,
          userPassword: base64Encode(infoRestoreCodePwd1),
        }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      if (data.code == 0) {
        setIsResetModalOpen(false); // Update the modal visibility state
        window.location.href = '#user/login';
        setMessagesModal([])
        setMessages([
          {
            type: 'success',
            content: `${data.status}`,
            id: 'server-error',
          },
        ]);
      } else {
        setMessagesModal([
          {
            type: 'error',
            content: `Error:${data.status}`,
            id: 'server-error',
          },
        ]);

      }
    } catch (error: any) {
      setMessagesModal([
        {
          type: 'error',
          content: `Error al contactar el servidor: ${error.message}`,
          id: 'server-error',
        },
      ]);
    } finally {
      setPendingJobCreation(false);
      setLoading(false)
    }
  }

  const handleValidatePasword = async () => {

    clearNotifications(setData);
    setMessagesModal([])
    setPendingJobCreation(true);
    try {
      setLoading(true)
      const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/user/login2',
          // 
        },
        body: JSON.stringify({
          userName: inputUser,
          userPassword: inputPassword,
          masters: true,
        }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        setIdUser(dataWeb.idUser);
        setIdAirport(dataWeb.idAirport);
        setName(dataWeb.name);

        Cookies.set("JWT", dataWeb.JWT, {
          expires: 7, // cookie expiration in days
          path: "/",     // available on all paths
          sameSite: "strict"
        });
        if (dataWeb.userAirports) {
          //console.log(dataWeb.userAirports)
          //setData({ ...data, userAirports: dataWeb.airports });
        }
        if (dataWeb.masters) {
          setData((prevData: any) => {
            // Start with the most recent state
            let newState = { ...prevData };
            if (dataWeb.masters.airports) newState.airports = dataWeb.masters.airports;
            if (dataWeb.masters.belts) newState.belts = dataWeb.masters.belts;
            if (dataWeb.masters.gates) newState.gates = dataWeb.masters.gates;
            if (dataWeb.masters.statuses) newState.statuses = dataWeb.masters.statuses;
            if (dataWeb.masters.airlines) newState.airlines = dataWeb.masters.airlines;
            if (dataWeb.userAirports) newState.userAirports = dataWeb.userAirports;

            return newState;
          });

        }


        setLoading(false)
        setPendingJobCreation(false);


        const rUrl = getParameter(window.location.hash, "returnUrl") || 'home';

        //setShouldRedirect(true);
        console.log("Redirecting to:", rUrl);
        setTimeout(() => {
          navigate(rUrl);
        }, 50);
        //navigate(rUrl)
        //window.location.hash = "#home";//rUrl

      } else {
        setInputPassword('')
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setPendingJobCreation(false);
      setLoading(false)
    }
  }

  useEffect(() => {
    if (getCookie("JWT") !== "" && idUser && idUser > 0) {
      fetch(`${getUrlVersion()}/routing/v1/?redirect2`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/login/data',
          'JWT': getCookie("JWT"),
        },
        body: JSON.stringify({ masters: true }),
      }).then(async (response) => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
        const data2 = await response.json();
        if (data2.code === 0) {

          if (data2.menu && data2.menu != menu) {
            setMenu(data2.menu)
          }
          if (data2.masters) {
            //localStorage.setItem("data", JSON.stringify(data2.masters))
            setData(saveMasters(data2, data))
            setIdUser(data2.idUser);
            setName(data2.name);
            setIdAirport(data2.idAirport);



          }

        }
      }).catch(err => console.error("Background fetch error", err));
    }
  }, [shouldRedirect]); //, JWT, idUser

  useEffect(() => {
    if (data) {
    }
  }, [data]);
  useEffect(() => {
    if (getCookie("JWT") !== "" && idUser && idUser > 0) {
      setShouldRedirect(true)
    }
  }, [setIdUser]);

  useEffect(() => {
    if (showPassword) {
      if (inputRefPwd.current) {
        inputRefPwd.current.focus();
      }
    }
  }, [showPassword]);
  setTimeout(function () {
    setInit(true);
  }, 0);


  const { navigate } = useRouter();
  const [pendingJobCreation, setPendingJobCreation] = useState(false);

  const handleBtnBack = () => {
    setIsDisabledUser(false);

    setInputPassword('');
    setInputUser('');
    setIsDisabledBtnNext(inputUser.length < 4)
    setShowPassword(false)
  };

  useEffect(() => {

  }, []);

  const validatePassword = (passwordToCheck: string) => {
    const newErrors: string[] = [];
    if (passwordToCheck.length < 8) {
      newErrors.push('Al menos 8 caracteres');
    }

    if (!/[#\$%\^&\*\(\)\-\+\=\[\]\{\}\\\|\;\:\'\"\,\<\>\.\/\?]/.test(passwordToCheck)) {
      newErrors.push('Debe incluir al menos un símbolo (ej: # $ . ?)');
    }
    if (!/(?=.*[a-z])/.test(passwordToCheck)) {
      newErrors.push('Debe incluir al menos una letra minúscula');
    }
    if (!/(?=.*[A-Z])/.test(passwordToCheck)) {
      newErrors.push('Debe incluir al menos una letra mayúscula');
    }
    if (!/(?=.*\d)/.test(passwordToCheck)) {
      newErrors.push('Debe incluir al menos un número');
    }
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#\$%\^&\*\(\)\-\+\=\[\]\{\}\\\|\;\:\'\"\,\<\>\.\/\?])/.test(passwordToCheck)) {
      //   newErrors.push('Debe incluir una mezcla de letras mayúsculas y minúsculas, números y símbolos');
    }

    setErrors(newErrors);
  }
  return (
    <>
      <CustomAppLayout
        toolsHide={true}
        contentType="form"
        content={
          <Form>
            <SpaceBetween size="xl">
              <div style={{ width: 400, margin: '0 auto' }}>
                <Container header={<Header>Identificación del usuario</Header>}>
                  <SpaceBetween size="l" direction="vertical">
                    <FormField
                      label="Usuario"
                      constraintText="Nombre de usuario registrado en la plataforma">
                      <Hotspot hotspotId="transcription-job-name">
                        <SpaceBetween direction="horizontal" size="xs">
                          <div ref={wrapperRef}>
                            <Input
                              controlId='infoUser'
                              value={inputUser}
                              placeholder="username"
                              disabled={isDisabledUser}
                              onChange={(event) => setInputUser(event.detail.value)}
                              onKeyDown={(event) => {
                                if (event.detail.key === 'Enter') {
                                  if (inputUser.length >= 4 && inputPassword.length == 0) {
                                    inputRefPwd.current?.focus();
                                  } else if (inputUser.length >= 4 && inputPassword.length >= 4) {
                                    handleValidatePasword();
                                  }
                                }
                              }}
                              autoComplete={false}
                              autoFocus
                            />
                          </div>
                        </SpaceBetween>
                      </Hotspot>
                    </FormField>
                    <FormField label="Contraseña"
                      info={inputPassword.length > 0 ? <Link onClick={() => {
                        setRevealPassword(!revealPassword);
                        passWordType == 'password' ? setPassWordType('text') : setPassWordType('password');
                      }}>{passWordType === "text" ? <Icon path={mdiEyeOutline} size={1} /> : <Icon path={mdiEyeOffOutline} size={1} />}</Link> : ""}
                    >
                      <Hotspot hotspotId="transcription-job-name">
                        <SpaceBetween direction="horizontal" size="xs">
                          <Input
                            controlId='infoPassword'
                            value={inputPassword}
                            type={passWordType as InputProps.Type}
                            onChange={handlePasswordChange}
                            ref={inputRefPwd}
                            autoComplete={"off"}
                            name="pwd"
                            onKeyDown={(event) => {
                              if (event.detail.key === 'Enter') {
                                if (inputUser.length >= 4 && inputPassword.length >= 4) {
                                  handleValidatePasword();
                                }
                              }
                            }}
                          />

                        </SpaceBetween>
                      </Hotspot>
                    </FormField>
                    <SpaceBetween direction="horizontal" size="xs">
                      <Box textAlign="right">
                        {inputUser.length > 2 && (
                          <Link variant="info" onClick={handleResetPassword}>Restaurar</Link>
                        )}
                      </Box>
                    </SpaceBetween>
                    <Box textAlign="center">
                      <Button onClick={handleValidatePasword} variant="primary" loading={pendingJobCreation} >Validar</Button>
                    </Box>
                  </SpaceBetween>

                </Container>
              </div>
            </SpaceBetween>

          </Form>
        }
      />
      <Modal
        visible={isResetModalOpen}
        onDismiss={handleCloseResetModal}
        header="Restaurar contraseña"
        size='small'
        footer={
          <div>

            <Box display={showModalStep1 ? 'block' : 'none'}>
              <Button onClick={handleCloseResetModal} variant="link">
                Cancelar
              </Button>
              <Button variant="primary"
                loading={pendingJobCreation}
                onClick={() => { /* Handle reset logic */ handleCloseSendResetModal(); }}>
                Enviar código
              </Button>
            </Box>

            <Box display={showModalStep2 ? 'block' : 'none'}>
              <Button onClick={handleCloseResetModal} variant="link">
                Cancelar
              </Button>
              <Button variant="primary"
                loading={pendingJobCreation}
                onClick={() => { /* Handle reset logic */ handleCloseSendRestoreModal(); }}>
                Restaurar
              </Button>
            </Box>

          </div>
        }
      >
        <SpaceBetween size='xs'>
          <Flashbar items={messagesModal} />
          <Box display={showModalStep1 ? 'block' : 'none'}>
            <p>¿Está seguro que desea <strong>restaurar su contraseña</strong>?. Se enviará un código temporal para su restablecimiento</p>
          </Box>
          <Box display={showModalStep2 ? 'block' : 'none'}>
            <Form>
              <SpaceBetween size="l" direction="vertical">
                <FormField label="Código de autorización">
                  <Input
                    controlId='infoRestoreCode'
                    value={infoRestoreCode}
                    autoComplete="new-password"
                    onChange={handleInfoRestoreCode}
                  />
                </FormField>

                <FormField label="Contraseña"


                  errorText={errors.length > 0 ?
                    errors.map((error, index) => (
                      <React.Fragment key={index}>
                        {error}
                        <br /> {/* Use <br /> for line breaks within the Alert */}
                      </React.Fragment>
                    ))
                    : undefined}
                  info={<Link onClick={() => setRevealNewPassword(!revealNewPassword)}>{revealNewPassword ? "Ocultar" : "Mostrar"}</Link>}>
                  <Input

                    controlId='infoRestoreCodePwd1'
                    value={infoRestoreCodePwd1}
                    type={revealNewPassword ? 'text' : 'password'}
                    autoComplete="new-password"
                    onChange={handleInfoRestoreCodePwd1}
                  />
                </FormField>

                <FormField label="Confirmación" info={<Link onClick={() => setRevealNewConfirmation(!revealNewConfirmation)}>{revealNewConfirmation ? "Ocultar" : "Mostrar"}</Link>}>
                  <Input
                    controlId='infoRestoreCodePwd2'
                    value={infoRestoreCodePwd2}
                    type={revealNewConfirmation ? 'text' : 'password'}
                    autoComplete="new-password"
                    onChange={handleInfoRestoreCodePwd2}
                  />
                </FormField>
              </SpaceBetween>
            </Form>
          </Box>
        </SpaceBetween>
      </Modal>
    </>
  );
};
